clearable<template>
  <div class="bottom-page">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
      <FormItem label="版本备案号">
        <Input v-model="formValidate.copyright" placeholder="请输入" style="width: 300px;" clearable/>
      </FormItem>
      <FormItem label="二维码">
        <div style="display:flex;align-items:center;">
          <div v-show="formValidate.QR_code" class="avatar">
            <img :src="formValidate.QR_code" alt />
            <Input v-model="formValidate.QR_code" style="display:none" clearable/>
          </div>
          <Upload
            :action="baseUrl+'/api/public/img'"
            :show-upload-list="false"
            :headers="header"
            :on-success="successHanlder"
            :format="['jpg','jpeg','png']"
          >
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
            <p class="sm-title">支持jpg、jpeg、png,小于5M</p>
          </Upload>
        </div>
      </FormItem>
      <FormItem label="联系电话" prop="contact_mobile">
        <Input v-model="formValidate.contact_mobile" placeholder="请输入" style="width: 300px;" clearable/>
      </FormItem>
      <FormItem label="微信">
        <Input v-model="formValidate.contact_wx" placeholder="请输入" style="width: 300px;" clearable/>
      </FormItem>
      <FormItem label="邮箱">
        <Input v-model="formValidate.contact_email" placeholder="请输入" style="width: 300px;" clearable/>
      </FormItem>
    </Form>
    <div class="submit">
      <Button @click="saveInfo" size="large" type="primary">保存</Button>
    </div>
  </div>
</template>

<script>
const buildConfig = require("../../../build/" + process.env.BUILD_ENV + ".js");
export default {
  name: "Bottom",
  data() {
    return {
      baseUrl: buildConfig.BASE_URL,
      header: {
        Authorization: "Bearer " + localStorage.adminToken
      },
      formValidate: {
        copyright: "",
        QR_code: "",
        contact_mobile: "",
        contact_wx: "",
        contact_email: ""
      },
      ruleValidate: {}
    };
  },
  created() {
    this.getBottom();
  },
  methods: {
    async getBottom() {
      this.formValidate = await this.$http.get(`/api/footerSetting`);
    },
    successHanlder(response) {
      this.formValidate.QR_code = response.data.path;
    },
    saveInfo() {
      this.$http.post(`/api/footerSetting`, this.formValidate).then(() => {
        this.$Message.success("成功");
        this.getBottom();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-page {
  padding: 20px;
}
.submit {
  margin-top: 20px;
  text-align: right;
}
.avatar {
  max-width: 100px;
  img {
    max-width: 100px;
  }
}
</style>